var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurnoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 587.97 243.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Turno_Gradient_-_Bigger_Section);}.cls-2{fill:url(#Turno_Gradient_Smaller_Section);}.cls-3{fill:url(#Original_-_Blue);}.cls-4{fill:#3d4465;}.cls-4,.cls-5{stroke-width:0px;}.cls-5{fill:#6b7b8b;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Turno_Gradient_Smaller_Section",
    x1: 21.27,
    y1: 89.09,
    x2: 119.78,
    y2: 89.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5abfc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#28c1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c49d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Turno_Gradient_-_Bigger_Section",
    x1: 29.16,
    y1: 85.01,
    x2: 153.77,
    y2: 85.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5abfc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#28c1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c49d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Original_-_Blue",
    x1: 25.79,
    y1: 111.03,
    x2: 119.78,
    y2: 111.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a74c5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5474c2",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#4475bb",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#2a78af",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#067b9f",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007c9d"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.02,31.91h-71.61v18.39h30.56v86.81h21.13V50.3h30.56v-7.3c0-5.93-4.71-11.1-10.64-11.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M332.62,93.99c.63-26.94,14.97-40.34,42.86-40.34h2.99v21.75h-8.15c-11.66,0-16.43,6.14-16.43,18.28v33.79c0,5.27-4.27,9.54-9.54,9.54h-11.73v-43.02Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M448.57,137c-6.83-.46-10.24-3.72-10.24-10.24v-42.22c-.47-8.54-5.12-12.73-14.28-12.73s-13.82,4.19-13.97,12.73v52.47h-20.96v-48.27c0-23.44,11.8-35.08,35.24-35.08s34.93,11.64,34.77,35.08v48.27h-10.56Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M545.42,96.91c0,28.63-12.74,43.1-37.91,43.1s-37.75-14.47-37.75-43.1,12.58-43.26,37.75-43.26,37.91,14.31,37.91,43.26ZM490.99,96.91c.16,16.2,5.66,24.38,16.36,24.38s16.05-8.49,16.2-25.01c0-16.2-5.35-24.22-16.05-24.22s-16.52,8.34-16.52,24.85Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M259.54,56.63c6.83.46,10.25,3.73,10.25,10.25v42.23c.47,8.54,5.12,12.73,14.29,12.73s13.82-4.19,13.97-12.73v-52.48h20.96v48.29c0,23.45-11.8,35.09-35.25,35.09s-34.94-11.65-34.78-35.09v-48.29h10.56Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M548.56,136.21v-8.79h-3.14v-1.79h8.4v1.79h-3.13v8.79h-2.14Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M555.18,136.21v-10.58h3.2l1.92,7.21,1.9-7.21h3.2v10.58h-1.98v-8.33l-2.1,8.33h-2.06l-2.09-8.33v8.33h-1.98Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Roundel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.53,78.92c-.16,1.86-.26,3.73-.26,5.63v.46c0,3.5.29,6.94.84,10.29.1.62.21,1.22.33,1.83,3.27,16.99,13.35,31.58,27.77,40.87,83.42,8.4,68.55-63.54,68.55-63.54h-.01c.33,2.11.54,4.27.59,6.47,0,.4.03.81.03,1.21,0,7.4-1.64,14.42-4.55,20.73-2.71,4.73-6.52,8.72-11.2,11.53-4.66,2.8-10.18,4.43-16.33,4.43-19.88,0-31.75-15.31-31.75-33.36v-.45c0-18.05,13.02-33.81,32.21-33.81,4.77,0,9.06.88,12.86,2.47-8.42-8.74-20.23-14.18-33.31-14.18-23.23,0-42.46,17.12-45.76,39.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.29,21.27c-25.91,0-47.23,13.12-58.14,32.65,8.66-12.46,22.89-20.74,39.09-21.26.53-.02,1.06-.05,1.59-.05,24.73,0,45.2,18.14,48.9,41.83h.01s14.86,71.95-68.55,63.55c10.52,6.78,23.35,10.75,37.55,10.75,37.92,0,66.02-28.1,66.02-63.28v-.45c0-15.37-5.41-29.47-14.68-40.49-11.95-14.19-30.32-23.25-51.8-23.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.44,98.86c-.49,1.35-1.03,2.67-1.62,3.96-.4.69-.82,1.36-1.26,2.02-9.11,15.6-31.71,29.85-87.77,3.65,4.84,12.07,13.35,22.33,24.41,29.46,64.84,6.53,70.3-35.49,69.51-54.53,0,0-.05,7.19-3.27,15.44"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M200.82,179.27c-1.88-1.08-3.33-2.61-4.34-4.59-1.01-1.98-1.51-4.3-1.51-6.97s.5-4.95,1.51-6.93c1.01-1.98,2.45-3.5,4.34-4.57,1.88-1.07,4.09-1.6,6.61-1.6,1.73,0,3.35.27,4.88.81,1.52.54,2.79,1.29,3.8,2.25l-1.51,3.38c-1.15-.94-2.3-1.61-3.44-2.03-1.14-.42-2.36-.63-3.65-.63-2.47,0-4.39.8-5.74,2.41-1.36,1.61-2.03,3.91-2.03,6.91s.67,5.35,2.02,6.97c1.34,1.62,3.26,2.43,5.76,2.43,1.3,0,2.51-.21,3.65-.63,1.14-.42,2.29-1.1,3.44-2.03l1.51,3.38c-1.01.96-2.27,1.71-3.8,2.25-1.52.54-3.15.81-4.88.81-2.52,0-4.72-.54-6.61-1.62Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M220.13,180.56v-26.5h4.46v26.5h-4.46Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M245.44,171.71h-12.53c.1,1.94.58,3.38,1.46,4.3s2.18,1.39,3.91,1.39c1.99,0,3.84-.65,5.54-1.94l1.3,3.1c-.86.7-1.93,1.25-3.19,1.67-1.26.42-2.54.63-3.83.63-2.98,0-5.32-.84-7.02-2.52-1.7-1.68-2.56-3.98-2.56-6.91,0-1.85.37-3.49,1.12-4.93.74-1.44,1.79-2.56,3.13-3.37,1.34-.8,2.87-1.21,4.57-1.21,2.5,0,4.47.81,5.92,2.43s2.18,3.85,2.18,6.68v.68ZM234.51,166.22c-.76.71-1.24,1.73-1.46,3.08h8.46c-.14-1.37-.56-2.4-1.24-3.1-.68-.7-1.63-1.04-2.83-1.04s-2.18.35-2.93,1.06Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M266.64,162.38v18.18h-4.43v-2.92c-.55,1.01-1.34,1.79-2.38,2.36-1.03.56-2.21.85-3.53.85-1.58,0-2.99-.38-4.21-1.15-1.22-.77-2.17-1.86-2.84-3.28-.67-1.42-1.01-3.06-1.01-4.93s.34-3.53,1.03-4.99c.68-1.45,1.64-2.58,2.86-3.38,1.22-.8,2.62-1.21,4.18-1.21,1.32,0,2.5.28,3.53.85,1.03.56,1.82,1.35,2.38,2.36v-2.74h4.43ZM260.99,175.77c.82-1.03,1.22-2.48,1.22-4.36s-.41-3.4-1.22-4.43c-.82-1.03-1.98-1.55-3.49-1.55s-2.65.53-3.47,1.6c-.83,1.07-1.24,2.55-1.24,4.45s.41,3.31,1.24,4.32,2,1.51,3.51,1.51,2.64-.52,3.46-1.55Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M288.46,169.4v11.16h-4.5v-10.94c0-1.44-.28-2.49-.83-3.15-.55-.66-1.4-.99-2.56-.99-1.37,0-2.47.44-3.31,1.31s-1.26,2.03-1.26,3.47v10.3h-4.46v-13.03c0-1.92-.1-3.64-.29-5.15h4.21l.32,2.99c.62-1.1,1.47-1.96,2.54-2.56,1.07-.6,2.27-.9,3.62-.9,4.34,0,6.52,2.5,6.52,7.49Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M292.96,154.14h5v4.43h-5v-4.43ZM293.25,180.56v-18.18h4.46v18.18h-4.46Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M319.56,169.4v11.16h-4.5v-10.94c0-1.44-.28-2.49-.83-3.15-.55-.66-1.4-.99-2.56-.99-1.37,0-2.47.44-3.31,1.31s-1.26,2.03-1.26,3.47v10.3h-4.46v-13.03c0-1.92-.1-3.64-.29-5.15h4.21l.32,2.99c.62-1.1,1.47-1.96,2.54-2.56,1.07-.6,2.27-.9,3.62-.9,4.34,0,6.52,2.5,6.52,7.49Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M341.92,162.38v17.6c0,2.83-.78,4.98-2.34,6.44-1.56,1.46-3.85,2.2-6.88,2.2-2.81,0-5.28-.59-7.42-1.76l.72-3.42c2.21,1.15,4.4,1.73,6.59,1.73,3.24,0,4.86-1.61,4.86-4.82v-3.6c-.55.98-1.36,1.78-2.41,2.39-1.06.61-2.24.92-3.56.92-1.58,0-2.99-.38-4.23-1.13s-2.2-1.82-2.88-3.2c-.68-1.38-1.03-2.96-1.03-4.73s.34-3.35,1.03-4.73c.68-1.38,1.64-2.45,2.88-3.2s2.65-1.13,4.23-1.13c1.34,0,2.54.28,3.58.85s1.84,1.35,2.39,2.36v-2.74h4.46ZM336.18,175.05c.85-.98,1.28-2.34,1.28-4.07s-.42-3.08-1.26-4.07c-.84-.98-2.02-1.48-3.53-1.48s-2.66.49-3.51,1.48c-.85.98-1.28,2.34-1.28,4.07s.43,3.08,1.28,4.07c.85.98,2.02,1.48,3.51,1.48s2.66-.49,3.51-1.48Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M351.35,175.52v3.31c0,1.27-.22,2.42-.65,3.46-.43,1.03-1.16,2.06-2.2,3.1l-1.84-1.48c1.13-1.2,1.78-2.32,1.94-3.35h-2.3v-5.04h5.04Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M364.49,178.55l1.26-3.17c1.94,1.44,4.16,2.16,6.66,2.16,1.08,0,1.91-.18,2.5-.54.59-.36.88-.86.88-1.51,0-.55-.21-.99-.61-1.31-.41-.32-1.1-.61-2.09-.85l-3.02-.68c-3.31-.72-4.97-2.41-4.97-5.08,0-1.1.31-2.08.94-2.93s1.5-1.52,2.63-2,2.44-.72,3.92-.72c1.3,0,2.54.2,3.74.59,1.2.4,2.26.97,3.17,1.71l-1.33,3.06c-1.82-1.34-3.7-2.02-5.62-2.02-1.03,0-1.84.19-2.41.58s-.86.91-.86,1.58c0,.53.17.95.52,1.26.35.31.94.58,1.78.79l3.1.68c1.8.41,3.11,1.04,3.94,1.89s1.24,1.96,1.24,3.33c0,1.68-.67,3.01-2.02,4-1.34.98-3.18,1.48-5.51,1.48-3.29,0-5.9-.77-7.85-2.3Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M387.08,179.7c-1.4-.77-2.48-1.87-3.24-3.29-.76-1.43-1.13-3.1-1.13-5.02s.38-3.59,1.13-5.02c.76-1.43,1.84-2.53,3.24-3.29,1.4-.77,3.03-1.15,4.88-1.15s3.43.38,4.82,1.15c1.39.77,2.47,1.87,3.22,3.29.76,1.43,1.13,3.1,1.13,5.02s-.38,3.59-1.13,5.02c-.76,1.43-1.83,2.53-3.22,3.29-1.39.77-3,1.15-4.82,1.15s-3.47-.38-4.88-1.15ZM395.43,175.83c.8-1,1.21-2.48,1.21-4.45s-.41-3.43-1.22-4.45c-.82-1.02-1.97-1.53-3.46-1.53s-2.68.51-3.49,1.53c-.82,1.02-1.22,2.5-1.22,4.45s.4,3.45,1.21,4.45c.8,1,1.96,1.49,3.47,1.49s2.71-.5,3.51-1.49Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M405.02,180.56v-26.5h4.46v26.5h-4.46Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M427.16,162.42h4.46l-7.96,18.14h-3.92l-7.85-18.14h4.72l5.22,13.03,5.33-13.03Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M449.56,171.71h-12.53c.1,1.94.58,3.38,1.46,4.3s2.18,1.39,3.91,1.39c1.99,0,3.84-.65,5.54-1.94l1.3,3.1c-.86.7-1.93,1.25-3.19,1.67-1.26.42-2.54.63-3.83.63-2.98,0-5.32-.84-7.02-2.52-1.7-1.68-2.56-3.98-2.56-6.91,0-1.85.37-3.49,1.12-4.93.74-1.44,1.79-2.56,3.13-3.37,1.34-.8,2.87-1.21,4.57-1.21,2.5,0,4.47.81,5.92,2.43s2.18,3.85,2.18,6.68v.68ZM438.63,166.22c-.76.71-1.24,1.73-1.46,3.08h8.46c-.14-1.37-.56-2.4-1.24-3.1-.68-.7-1.63-1.04-2.83-1.04s-2.18.35-2.93,1.06Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M470.76,154.07v26.5h-4.43v-2.92c-.55,1.01-1.34,1.79-2.38,2.36-1.03.56-2.21.85-3.53.85-1.56,0-2.95-.4-4.18-1.19-1.22-.79-2.18-1.91-2.86-3.37-.68-1.45-1.03-3.11-1.03-4.99s.33-3.52,1.01-4.93c.67-1.42,1.62-2.51,2.84-3.29,1.22-.78,2.63-1.17,4.21-1.17,1.3,0,2.45.27,3.47.81,1.02.54,1.81,1.3,2.36,2.29v-10.94h4.5ZM465.09,175.77c.83-1.03,1.24-2.5,1.24-4.39s-.41-3.36-1.22-4.39c-.82-1.03-1.97-1.55-3.46-1.55s-2.68.51-3.51,1.53c-.83,1.02-1.24,2.47-1.24,4.34s.41,3.37,1.24,4.43c.83,1.06,1.99,1.58,3.47,1.58s2.65-.52,3.47-1.55Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M475.19,175.52h5.04v5.04h-5.04v-5.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnoLogo);
export default __webpack_public_path__ + "static/media/turnoLogo.184a4eedcab733fdda89d3fe31d4da01.svg";
export { ForwardRef as ReactComponent };